import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import useBreakPoints from "../hooks/useBreakPoints";
import { Link, useLocation, useNavigate  } from "react-router-dom";
import Logo from "../assets/images/Logo.png";
import Logo2 from "../assets/images/Logo-2.png";
import { headerData, SideBarData } from "../helper/staticData";

import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
// import CartDrawer from "../Pages/Cart/CartDrawer";
import { MyContext } from "../hooks/useContextProvider";
import Login from "../Pages/Authentication/Login";
import { Bell, X } from "lucide-react";
import { toast } from "react-toastify";

const Header = () => {
  const navigate = useNavigate();
  const { token, callWishListApi, callCartDetails, cartList, wishList } =
    useContext(MyContext);
  console.log("token: ", token);

  const { isTablet, isLaptop } = useBreakPoints();
  const dropdownRef = useRef(null);
  const location = useLocation();
  const guestMode = localStorage.getItem("guestMode");
  const [notificationList, setNotificationList] = useState([]);
  const [notificationCount, setNotificationCount] = useState(null);
  const [loading, setloading] = useState(true);
  const [groupName, setGroupName] = useState();
  const [show, setShow] = useState(false);

  const [cartDrawerOpen, setCartDrawerOpen] = useState(false);
  const [open, setOpen] = useState(false);

  const [subOpen, setSubOpen] = useState({ open: false, id: "" });
  const [loginModal, setLoginModal] = useState(false);

  useEffect(() => {
    if (!isTablet) {
      setOpen(false);
    }

    callWishListApi();
    callCartDetails();
  }, [isTablet]);

  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with custom options
  }, []);
  const [wsConnected, setWsConnected] = useState(false);
  const wsRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);

  useEffect(() => {
    if (token) {
      callNotificationListApi();
      let userDetails = JSON.parse(localStorage.getItem("userDetails"));
      if (userDetails !== "" && userDetails !== null) {
        setGroupName("User_" + userDetails.id + "/");
      }
    }
  }, [token]);

  const callNotificationListApi = (showAlert) => {
    setloading(true);
    const token = localStorage.getItem("token");
    const ipAddress = localStorage.getItem("ipaddress");

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}getcustomernotifications?ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setloading(false);
          setNotificationList(data["notifications"]);
          setNotificationCount(data["notifyCount"]);
          if (showAlert === true) {
            if (data["notifications"].length > 0) {
              const show_notification = data["notifications"][0];
              alert(show_notification.message);
            }
          }
        } else {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("There was an error, Please try again later.");
        }, 1000);
      });
  };

  const connectWebSocket = useCallback((groupName) => {
    if (wsRef.current?.readyState === WebSocket.OPEN) {
      console.log("WebSocket already connected");
      return;
    }

    const socket = new WebSocket(
      `wss://api.k9interior.com/ws/CustomerNotify/${groupName}`
    ); // Ensure lowercase

    socket.onopen = () => {
      console.log("WebSocket connected");
      setWsConnected(true);
      wsRef.current = socket;

      // If there's a pending reconnection timeout, clear it
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
        reconnectTimeoutRef.current = null;
      }
    };

    socket.onmessage = (event) => {
      console.log("event: ", event);
      const response = event.data;
      console.log("response: ", response);

      if (response === "Reload") {
        callNotificationListApi();
        console.log("Reload page event received");
      }
    };

    socket.onclose = () => {
      console.log("WebSocket disconnected");
      setWsConnected(false);
      wsRef.current = null;

      // Attempt to reconnect after a delay
      // reconnectTimeoutRef.current = setTimeout(() => {
      //   console.log("Attempting to reconnect...");
      //   connectWebSocket();
      // }, 3000);
    };

    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      socket.close();
    };

    return socket;
  }, []);

  useEffect(() => {
    if (groupName) {
      console.log("groupName: ", groupName);

      const socket = connectWebSocket(groupName);
      return () => {
        if (socket) {
          socket.close();
        }
        if (reconnectTimeoutRef.current) {
          clearTimeout(reconnectTimeoutRef.current);
        }
      };
    }
  }, [connectWebSocket, groupName]);

  const viewNotificationApi = (id) => {
    setloading(true);
    const token = localStorage.getItem("token");
    let formData = new FormData();
    formData.append("id", id);
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
      },
      body: formData,
    };

    fetch(
      `${process.env.REACT_APP_API_URL}viewcustomernotification`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setloading(false);
          callNotificationListApi(true);
        } else {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  return (
    <div
      id="header-wrapper"
      class="header-top-absolute"
      style={{ marginBottom: location.pathname !== "/" && 0 }}
    >
      <header id="header">
        <div className="wdt-elementor-container-fluid">
          <div id="header-281" className="wdt-header-tpl header-281">
            <div
              data-elementor-type="wp-post"
              data-elementor-id="281"
              className="elementor elementor-281"
            >
              <section
                className="custom-slider-home-2 elementor-section elementor-top-section elementor-element elementor-element-c044770 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                data-id="c044770"
                data-element_type="section"
                data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-79f615e"
                    data-id="79f615e"
                    data-element_type="column"
                  >
                    <div className=" elementor-widget-wrap elementor-element-populated">
                      {/* First Black Header */}
                      <section
                        className="custom-slider-home-2 elementor-section elementor-inner-section elementor-element elementor-element-3b11ec7 wdt-dark-bg wdt-section-wrap-col elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="3b11ec7"
                        data-element_type="section"
                        data-settings='{"background_background":"classic","wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                      >
                        <div className="elementor-container elementor-column-gap-no">
                          <div
                            className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-ca95cb9 elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile"
                            data-id="ca95cb9"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-9c78ab3 elementor-icon-list--layout-inline elementor-list-item-link-inline wdt-cus-header-top-bar-list elementor-widget elementor-widget-icon-list"
                                data-id="9c78ab3"
                                data-element_type="widget"
                                data-settings='{"wdt_animation_effect":"none"}'
                                data-widget_type="icon-list.default"
                              >
                                <div className="elementor-widget-container">
                                  <ul className="elementor-icon-list-items elementor-inline-items">
                                    <li className="elementor-icon-list-item elementor-inline-item">
                                      <Link to="mailto:k9.vadodara@gmail.com">
                                        <span className="elementor-icon-list-text">
                                          k9.vadodara@gmail.com
                                        </span>
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b116db0 elementor-hidden-mobile_extra elementor-hidden-mobile"
                            data-id="b116db0"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-f3aea61 wdt-header-image-with-text elementor-widget-tablet_extra__width-auto elementor-widget elementor-widget-wdt-text-image"
                                data-id="f3aea61"
                                data-element_type="widget"
                                data-settings='{"wdt_animation_effect":"none"}'
                                data-widget_type="wdt-text-image.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="wdt-elementor-repeater-container">
                                    <p className="wdt-elementor-repeater-container-wrapper">
                                      <span className="elementor-repeater-item-5dafcfb">
                                        <img src="https://furniforma.wpengine.com/wp-content/uploads/2024/10/FF-Fire-Image.png" />
                                      </span>
                                      <span className="wdt-text-tile elementor-repeater-item-9aed926 text-white">
                                        Stylish Furniture, Timeless Design,
                                        Comfort Guaranteed
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-f646c4f"
                            data-id="f646c4f"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-fc094f8 elementor-widget__width-auto elementor-widget elementor-widget-wp-widget-gtranslate"
                                data-id="fc094f8"
                                data-element_type="widget"
                                data-settings='{"wdt_animation_effect":"none"}'
                                data-widget_type="wp-widget-gtranslate.default"
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    className="gtranslate_wrapper"
                                    id="gt-wrapper-68164186"
                                  ></div>
                                </div>
                              </div>

                              <div
                                className="elementor-element elementor-element-088f642 elementor-align-right elementor-widget__width-auto wdt-cus-header-top-bar-header-icons elementor-widget elementor-widget-wdt-header-icons"
                                data-id="088f642"
                                data-element_type="widget"
                                data-settings='{"wdt_animation_effect":"none"}'
                                data-widget_type="wdt-header-icons.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="woocommerce">
                                    <div className="wdt-header-icons-list">
                                      <div className="wdt-header-icons-list-item user-authlink-item">
                                        <div className="wdt-user-authlink-menu-icon">
                                          {isLaptop && (
                                            <>
                                              <div className="wdt-header-icons-list-item cart-item">
                                                <div className="wdt-shop-menu-icon">
                                                  {token ? (
                                                    <Link to="/cart">
                                                      <span className="wdt-shop-menu-icon-wrapper">
                                                        <span className="wdt-shop-menu-cart-inner">
                                                          <span className="wdt-shop-menu-cart-icon">
                                                            <i>
                                                              <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 100 92.3"
                                                              >
                                                                <path d="M1,3.7c0.9-2.2,2.5-2.9,4.8-2.8C9.2,1,12.6,1,16,1c2.7,0,3.9,0.9,4.5,3.6c1,4.3,2.1,8.7,3.1,13.1c0.4,0,0.9,0,1.3,0 c23.1,0,46.2,0,69.4,0c0.5,0,1,0,1.4,0.1c2.4,0.3,3.7,2.3,3.1,4.7c-2.7,10.9-5.3,21.8-8,32.7c-0.3,1.1-0.5,2.1-0.8,3.2 c-0.6,2.2-1.8,3.1-4.1,3.2c-7.5,0-15.1,0-22.6,0c-11.1,0-22.1,0-33.2,0c-2.9,0-4-0.9-4.7-3.7c-3.8-16.2-7.7-32.3-11.5-48.5 c-0.2-0.7-0.4-0.9-1.1-0.9c-2.4,0-4.7-0.1-7.1,0C3.6,8.5,2,7.8,1,5.6V3.7L1,3.7z M90.6,25.2H25.4c2.3,9.6,4.6,19.2,6.8,28.9h0.8 c16.5,0,33,0,49.6,0c0.6,0,0.9-0.2,1.1-0.8c1.4-5.9,2.9-11.8,4.4-17.7C88.9,32.1,89.8,28.6,90.6,25.2z"></path>
                                                                <path d="M78.6,91.3c-6.8,0-12.3-5.6-12.2-12.3c0-6.8,5.6-12.3,12.3-12.3c6.8,0.1,12.2,5.6,12.2,12.4C90.8,85.9,85.3,91.4,78.6,91.3z  M73.7,79c0,2.7,2.2,4.9,4.8,5c2.6,0,4.9-2.2,4.9-4.9c0-2.6-2.2-4.9-4.8-4.9C76,74.1,73.7,76.3,73.7,79z"></path>
                                                                <path d="M34.2,91.3C27.4,91.3,22,85.8,22,79c0-6.8,5.5-12.3,12.2-12.3c6.7,0,12.3,5.6,12.2,12.3C46.4,85.9,40.9,91.4,34.2,91.3 L34.2,91.3z M39.1,79c0-2.7-2.2-4.9-4.9-4.9c-2.6,0-4.9,2.3-4.9,4.9c0,2.7,2.3,4.9,4.9,4.9C36.9,83.9,39.1,81.7,39.1,79z"></path>
                                                              </svg>
                                                            </i>
                                                          </span>
                                                          <span className="wdt-shop-menu-cart-number">
                                                            {cartList?.length}
                                                          </span>
                                                        </span>
                                                        <span className="wdt-shop-menu-cart-totals"></span>
                                                      </span>
                                                    </Link>
                                                  ) : (
                                                    <Link
                                                      onClick={() => {
                                                        setLoginModal(true);
                                                      }}
                                                    >
                                                      <span className="wdt-shop-menu-icon-wrapper">
                                                        <span className="wdt-shop-menu-cart-inner">
                                                          <span className="wdt-shop-menu-cart-icon">
                                                            <i>
                                                              <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 100 92.3"
                                                              >
                                                                <path d="M1,3.7c0.9-2.2,2.5-2.9,4.8-2.8C9.2,1,12.6,1,16,1c2.7,0,3.9,0.9,4.5,3.6c1,4.3,2.1,8.7,3.1,13.1c0.4,0,0.9,0,1.3,0 c23.1,0,46.2,0,69.4,0c0.5,0,1,0,1.4,0.1c2.4,0.3,3.7,2.3,3.1,4.7c-2.7,10.9-5.3,21.8-8,32.7c-0.3,1.1-0.5,2.1-0.8,3.2 c-0.6,2.2-1.8,3.1-4.1,3.2c-7.5,0-15.1,0-22.6,0c-11.1,0-22.1,0-33.2,0c-2.9,0-4-0.9-4.7-3.7c-3.8-16.2-7.7-32.3-11.5-48.5 c-0.2-0.7-0.4-0.9-1.1-0.9c-2.4,0-4.7-0.1-7.1,0C3.6,8.5,2,7.8,1,5.6V3.7L1,3.7z M90.6,25.2H25.4c2.3,9.6,4.6,19.2,6.8,28.9h0.8 c16.5,0,33,0,49.6,0c0.6,0,0.9-0.2,1.1-0.8c1.4-5.9,2.9-11.8,4.4-17.7C88.9,32.1,89.8,28.6,90.6,25.2z"></path>
                                                                <path d="M78.6,91.3c-6.8,0-12.3-5.6-12.2-12.3c0-6.8,5.6-12.3,12.3-12.3c6.8,0.1,12.2,5.6,12.2,12.4C90.8,85.9,85.3,91.4,78.6,91.3z  M73.7,79c0,2.7,2.2,4.9,4.8,5c2.6,0,4.9-2.2,4.9-4.9c0-2.6-2.2-4.9-4.8-4.9C76,74.1,73.7,76.3,73.7,79z"></path>
                                                                <path d="M34.2,91.3C27.4,91.3,22,85.8,22,79c0-6.8,5.5-12.3,12.2-12.3c6.7,0,12.3,5.6,12.2,12.3C46.4,85.9,40.9,91.4,34.2,91.3 L34.2,91.3z M39.1,79c0-2.7-2.2-4.9-4.9-4.9c-2.6,0-4.9,2.3-4.9,4.9c0,2.7,2.3,4.9,4.9,4.9C36.9,83.9,39.1,81.7,39.1,79z"></path>
                                                              </svg>
                                                            </i>
                                                          </span>
                                                          <span className="wdt-shop-menu-cart-number">
                                                            {cartList?.length}
                                                          </span>
                                                        </span>
                                                        <span className="wdt-shop-menu-cart-totals"></span>
                                                      </span>
                                                    </Link>
                                                  )}
                                                </div>
                                              </div>
                                              <div className="wdt-wishlist-count">
                                                {token ? (
                                                  <Link
                                                    to="/wishlist"
                                                    name=""
                                                    aria-label=""
                                                    className="wishlist_products_counter  top_wishlist- no-txt wishlist-counter-with-products"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="24"
                                                      height="24"
                                                      viewBox="0 0 24 24"
                                                      fill="white"
                                                      stroke="white"
                                                      stroke-width="2"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                      class="lucide lucide-heart"
                                                    >
                                                      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                                    </svg>
                                                    <span className="wishlist_products_counter_text"></span>

                                                    <span className="wishlist_products_counter_number">
                                                      {wishList?.length}
                                                    </span>
                                                  </Link>
                                                ) : (
                                                  <Link
                                                    onClick={() => {
                                                      setLoginModal(true);
                                                    }}
                                                    name=""
                                                    aria-label=""
                                                    className="wishlist_products_counter  top_wishlist- no-txt wishlist-counter-with-products"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="24"
                                                      height="24"
                                                      viewBox="0 0 24 24"
                                                      fill="white"
                                                      stroke="white"
                                                      stroke-width="2"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                      class="lucide lucide-heart"
                                                    >
                                                      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                                    </svg>
                                                    <span className="wishlist_products_counter_text"></span>

                                                    <span className="wishlist_products_counter_number">
                                                      {wishList?.length}
                                                    </span>
                                                  </Link>
                                                )}
                                              </div>
                                            </>
                                          )}

                                          {token ? (
                                            <>
                                              <div class="others-options d-flex align-items-center">
                                                <div
                                                  class="optional-item"
                                                  ref={dropdownRef}
                                                >
                                                  <div class="dropdown profile-nav-item">
                                                    <Link
                                                      to="#"
                                                      class={`dropdown-bs-toggle ${
                                                        show ? "show" : ""
                                                      }`}
                                                      data-bs-toggle="dropdown"
                                                      aria-haspopup="true"
                                                      aria-expanded="false"
                                                      onClick={() => {
                                                        setShow(!show);
                                                      }}
                                                    >
                                                      <div
                                                        class="menu-profile "
                                                        style={{
                                                          marginRight: 10,
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <Bell
                                                          color="white"
                                                          size={20}
                                                          style={{
                                                            height: 20,
                                                            width: 20,
                                                          }}
                                                        />
                                                        <span className="custom-Notification-cricle">
                                                          {notificationCount}
                                                        </span>
                                                      </div>
                                                    </Link>

                                                    <div
                                                      class={`dropdown-menu ${
                                                        show ? "show" : ""
                                                      }`}
                                                      style={{
                                                        maxWidth: 300,
                                                        left: -150,
                                                        minWidth: 300,
                                                      }}
                                                    >
                                                      <div
                                                        class="dropdown-header d-flex flex-column align-items-center"
                                                        style={{ padding: 0 }}
                                                      ></div>

                                                      <div class="dropdown-body">
                                                        <div
                                                          className="dropdown-head bg-success bg-pattern rounded-top"
                                                          style={{
                                                            background:
                                                              "rgb(25 135 84)",
                                                          }}
                                                        >
                                                          <div
                                                            className="p-3"
                                                            style={{
                                                              padding: "1rem",
                                                            }}
                                                          >
                                                            <div
                                                              className="align-items-center"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "space-between",
                                                              }}
                                                            >
                                                              <h6
                                                                className="m-0 fs-16 fw-semibold text-white"
                                                                style={{
                                                                  fontSize: 16,
                                                                  margin: 0,
                                                                }}
                                                              >
                                                                {" "}
                                                                Notifications{" "}
                                                              </h6>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div
                                                          style={{
                                                            maxHeight: "300px",
                                                            overflow: "auto",
                                                            marginTop: 10,
                                                          }}
                                                          className="pe-2 mt-3"
                                                        >
                                                          {notificationList.length >
                                                            0 &&
                                                            notificationList.map(
                                                              (item, i) => (
                                                                <div
                                                                  key={i}
                                                                  className="text-reset notification-item d-block dropdown-item position-relative"
                                                                >
                                                                  <div
                                                                    className="d-flex align-items-center"
                                                                    style={{
                                                                      display:
                                                                        "flex",
                                                                      alignItems:
                                                                        "center",
                                                                      justifyContent:
                                                                        "space-between",
                                                                    }}
                                                                  >
                                                                    <div className="flex-1">
                                                                      <Link
                                                                        onClick={() => {
                                                                          viewNotificationApi(
                                                                            item?.id
                                                                          );
                                                                        }}
                                                                        className="stretched-link"
                                                                      >
                                                                        <h6
                                                                          className="mt-0 mb-2 lh-base"
                                                                          style={{
                                                                            inlineSize: 200,
                                                                            textWrapMode:
                                                                              "wrap",
                                                                            color:
                                                                              "black",
                                                                            fontSize: 16,
                                                                            marginTop: 0,
                                                                            fontFamily:
                                                                              '"Nunito Sans", sans-serif',
                                                                          }}
                                                                        >
                                                                          {
                                                                            item?.message
                                                                          }
                                                                        </h6>
                                                                      </Link>
                                                                    </div>
                                                                    <div className="px-2 fs-15">
                                                                      <i
                                                                        className="ri-close-circle-fill"
                                                                        style={{
                                                                          fontSize: 20,
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                      ></i>
                                                                    </div>
                                                                  </div>
                                                                  <p
                                                                    style={{
                                                                      textWrapMode:
                                                                        "wrap",
                                                                      color:
                                                                        "black",
                                                                      fontSize: 11,
                                                                      marginTop: 0,
                                                                      fontFamily:
                                                                        '"Nunito Sans", sans-serif',
                                                                    }}
                                                                  >
                                                                    <span>
                                                                      <i className="mdi mdi-clock-outline"></i>{" "}
                                                                      {
                                                                        item?.created_at
                                                                      }
                                                                    </span>
                                                                  </p>
                                                                </div>
                                                              )
                                                            )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <Link to={"/profile"}>
                                                <span
                                                  style={{ marginLeft: 10 }}
                                                >
                                                  <i>
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      x="0px"
                                                      y="0px"
                                                      viewBox="0 0 100 100"
                                                      style={{
                                                        enableBackground:
                                                          "new 0 0 100 100",
                                                      }}
                                                    >
                                                      <path d="M46.7,100L46.7,100c-0.4-0.1-0.8-0.1-1.2-0.1c-0.8-0.1-1.6-0.2-2.5-0.3c-9.9-1.5-18.6-5.4-25.6-11.7C4,76-1.7,60.9,0.5,43 C1.6,33.4,5.5,24.8,12,17.5C22.3,5.9,34.9,0,49.3,0c3.3,0,6.7,0.3,10.1,0.9C71.5,3,81.7,9.3,89.7,19.6c5,6.4,8.2,13.7,9.6,21.7 c0.2,1.2,0.4,2.5,0.5,3.7c0.1,0.6,0.1,1.1,0.2,1.7l0,0.1v6.7c0,0-0.1,0.3-0.1,0.4c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.6-0.1,1.1-0.2,1.7 c-0.1,1.1-0.3,2.3-0.5,3.5C97,70.1,92,79.2,84,86.6c-7.2,6.7-15.8,11-25.4,12.6c-1.2,0.2-2.5,0.4-3.6,0.5c-0.6,0.1-1.1,0.1-1.7,0.2 l-0.1,0L46.7,100L46.7,100z M23.1,82.9c7.5,6.2,17,9.6,26.9,9.6c9.9,0,19.4-3.4,26.9-9.6C75.3,69.7,63.6,59.4,50,59.4h-0.2 C34.8,59.5,24.3,71.6,23.1,82.9z M63.3,54.6c4.8,2,9,5,12.4,8.8c3.4,3.8,5.9,8.2,7.4,13.2c12-14.3,14.2-39.5-3.2-56.7 c-8.1-8-18.7-12.4-30-12.4c-12.6,0-24.5,5.6-32.7,15.4C2.7,40.4,5.5,63.5,16.8,76.5c3.3-10.2,9.9-17.5,19.8-21.9 c-4.7-3.8-7.5-9-8.1-14.9C28,33.6,30,27.5,34.2,23.1c4.2-4.5,9.8-6.9,15.8-6.9c5.7,0,11.1,2.2,15.2,6.3c4.4,4.3,6.7,10.7,6.2,17 C70.9,45.4,68.1,50.7,63.3,54.6L63.3,54.6z M50,23.5c-7.7,0-14,6.3-14.1,14.1c0,3.7,1.4,7.2,4,9.9c2.7,2.7,6.3,4.2,10.1,4.2 c7.8,0,14.1-6.3,14.1-14.1C64.1,29.9,57.8,23.6,50,23.5L50,23.5L50,23.5z"></path>
                                                    </svg>
                                                  </i>
                                                  <span className="icotype-label">
                                                    Profile
                                                  </span>
                                                </span>
                                              </Link>
                                            </>
                                          ) : (
                                            <Link
                                              onClick={() => {
                                                setLoginModal(true);
                                              }}
                                            >
                                              <span>
                                                <i>
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    x="0px"
                                                    y="0px"
                                                    viewBox="0 0 100 100"
                                                    style={{
                                                      enableBackground:
                                                        "new 0 0 100 100",
                                                    }}
                                                  >
                                                    <path d="M46.7,100L46.7,100c-0.4-0.1-0.8-0.1-1.2-0.1c-0.8-0.1-1.6-0.2-2.5-0.3c-9.9-1.5-18.6-5.4-25.6-11.7C4,76-1.7,60.9,0.5,43 C1.6,33.4,5.5,24.8,12,17.5C22.3,5.9,34.9,0,49.3,0c3.3,0,6.7,0.3,10.1,0.9C71.5,3,81.7,9.3,89.7,19.6c5,6.4,8.2,13.7,9.6,21.7 c0.2,1.2,0.4,2.5,0.5,3.7c0.1,0.6,0.1,1.1,0.2,1.7l0,0.1v6.7c0,0-0.1,0.3-0.1,0.4c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.6-0.1,1.1-0.2,1.7 c-0.1,1.1-0.3,2.3-0.5,3.5C97,70.1,92,79.2,84,86.6c-7.2,6.7-15.8,11-25.4,12.6c-1.2,0.2-2.5,0.4-3.6,0.5c-0.6,0.1-1.1,0.1-1.7,0.2 l-0.1,0L46.7,100L46.7,100z M23.1,82.9c7.5,6.2,17,9.6,26.9,9.6c9.9,0,19.4-3.4,26.9-9.6C75.3,69.7,63.6,59.4,50,59.4h-0.2 C34.8,59.5,24.3,71.6,23.1,82.9z M63.3,54.6c4.8,2,9,5,12.4,8.8c3.4,3.8,5.9,8.2,7.4,13.2c12-14.3,14.2-39.5-3.2-56.7 c-8.1-8-18.7-12.4-30-12.4c-12.6,0-24.5,5.6-32.7,15.4C2.7,40.4,5.5,63.5,16.8,76.5c3.3-10.2,9.9-17.5,19.8-21.9 c-4.7-3.8-7.5-9-8.1-14.9C28,33.6,30,27.5,34.2,23.1c4.2-4.5,9.8-6.9,15.8-6.9c5.7,0,11.1,2.2,15.2,6.3c4.4,4.3,6.7,10.7,6.2,17 C70.9,45.4,68.1,50.7,63.3,54.6L63.3,54.6z M50,23.5c-7.7,0-14,6.3-14.1,14.1c0,3.7,1.4,7.2,4,9.9c2.7,2.7,6.3,4.2,10.1,4.2 c7.8,0,14.1-6.3,14.1-14.1C64.1,29.9,57.8,23.6,50,23.5L50,23.5L50,23.5z"></path>
                                                  </svg>
                                                </i>
                                                <span className="icotype-label">
                                                  Log In
                                                </span>
                                              </span>
                                            </Link>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* Second Logo Header With Menu */}
                      <section
                        className="custom-slider-home-2 elementor-section elementor-inner-section elementor-element elementor-element-b8bea83 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="b8bea83"
                        data-element_type="section"
                        data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                      >
                        <div className="elementor-container elementor-column-gap-no">
                          {/* Left Side first Section */}
                          <div
                            className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-21bdb84"
                            data-id="21bdb84"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              {/* Icon Section For Small Laptop Start */}
                              <div
                                className="elementor-element elementor-element-5fe02d3 elementor-align-right elementor-tablet_extra-align-left elementor-hidden-desktop elementor-hidden-laptop elementor-hidden-mobile_extra elementor-hidden-mobile  elementor-widget elementor-widget-wdt-header-icons"
                                data-id="5fe02d3"
                                data-element_type="widget"
                                data-settings='{"_animation":"fadeIn","_animation_delay":300,"wdt_animation_effect":"none"}'
                                data-widget_type="wdt-header-icons.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="woocommerce">
                                    <div className="wdt-header-icons-list">
                                      <div className="wdt-header-icons-list-item cart-item">
                                        <div className="wdt-shop-menu-icon">
                                          {token ? (
                                            <Link to="/cart">
                                              <span className="wdt-shop-menu-icon-wrapper">
                                                <span className="wdt-shop-menu-cart-inner">
                                                  <span className="wdt-shop-menu-cart-icon">
                                                    <i>
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 100 92.3"
                                                      >
                                                        <path d="M1,3.7c0.9-2.2,2.5-2.9,4.8-2.8C9.2,1,12.6,1,16,1c2.7,0,3.9,0.9,4.5,3.6c1,4.3,2.1,8.7,3.1,13.1c0.4,0,0.9,0,1.3,0 c23.1,0,46.2,0,69.4,0c0.5,0,1,0,1.4,0.1c2.4,0.3,3.7,2.3,3.1,4.7c-2.7,10.9-5.3,21.8-8,32.7c-0.3,1.1-0.5,2.1-0.8,3.2 c-0.6,2.2-1.8,3.1-4.1,3.2c-7.5,0-15.1,0-22.6,0c-11.1,0-22.1,0-33.2,0c-2.9,0-4-0.9-4.7-3.7c-3.8-16.2-7.7-32.3-11.5-48.5 c-0.2-0.7-0.4-0.9-1.1-0.9c-2.4,0-4.7-0.1-7.1,0C3.6,8.5,2,7.8,1,5.6V3.7L1,3.7z M90.6,25.2H25.4c2.3,9.6,4.6,19.2,6.8,28.9h0.8 c16.5,0,33,0,49.6,0c0.6,0,0.9-0.2,1.1-0.8c1.4-5.9,2.9-11.8,4.4-17.7C88.9,32.1,89.8,28.6,90.6,25.2z"></path>
                                                        <path d="M78.6,91.3c-6.8,0-12.3-5.6-12.2-12.3c0-6.8,5.6-12.3,12.3-12.3c6.8,0.1,12.2,5.6,12.2,12.4C90.8,85.9,85.3,91.4,78.6,91.3z  M73.7,79c0,2.7,2.2,4.9,4.8,5c2.6,0,4.9-2.2,4.9-4.9c0-2.6-2.2-4.9-4.8-4.9C76,74.1,73.7,76.3,73.7,79z"></path>
                                                        <path d="M34.2,91.3C27.4,91.3,22,85.8,22,79c0-6.8,5.5-12.3,12.2-12.3c6.7,0,12.3,5.6,12.2,12.3C46.4,85.9,40.9,91.4,34.2,91.3 L34.2,91.3z M39.1,79c0-2.7-2.2-4.9-4.9-4.9c-2.6,0-4.9,2.3-4.9,4.9c0,2.7,2.3,4.9,4.9,4.9C36.9,83.9,39.1,81.7,39.1,79z"></path>
                                                      </svg>
                                                    </i>
                                                  </span>
                                                  <span className="wdt-shop-menu-cart-number">
                                                    {cartList?.length}
                                                  </span>
                                                </span>
                                                <span className="wdt-shop-menu-cart-totals"></span>
                                              </span>
                                            </Link>
                                          ) : (
                                            <Link
                                              onClick={() => {
                                                setLoginModal(true);
                                              }}
                                            >
                                              <span className="wdt-shop-menu-icon-wrapper">
                                                <span className="wdt-shop-menu-cart-inner">
                                                  <span className="wdt-shop-menu-cart-icon">
                                                    <i>
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 100 92.3"
                                                      >
                                                        <path d="M1,3.7c0.9-2.2,2.5-2.9,4.8-2.8C9.2,1,12.6,1,16,1c2.7,0,3.9,0.9,4.5,3.6c1,4.3,2.1,8.7,3.1,13.1c0.4,0,0.9,0,1.3,0 c23.1,0,46.2,0,69.4,0c0.5,0,1,0,1.4,0.1c2.4,0.3,3.7,2.3,3.1,4.7c-2.7,10.9-5.3,21.8-8,32.7c-0.3,1.1-0.5,2.1-0.8,3.2 c-0.6,2.2-1.8,3.1-4.1,3.2c-7.5,0-15.1,0-22.6,0c-11.1,0-22.1,0-33.2,0c-2.9,0-4-0.9-4.7-3.7c-3.8-16.2-7.7-32.3-11.5-48.5 c-0.2-0.7-0.4-0.9-1.1-0.9c-2.4,0-4.7-0.1-7.1,0C3.6,8.5,2,7.8,1,5.6V3.7L1,3.7z M90.6,25.2H25.4c2.3,9.6,4.6,19.2,6.8,28.9h0.8 c16.5,0,33,0,49.6,0c0.6,0,0.9-0.2,1.1-0.8c1.4-5.9,2.9-11.8,4.4-17.7C88.9,32.1,89.8,28.6,90.6,25.2z"></path>
                                                        <path d="M78.6,91.3c-6.8,0-12.3-5.6-12.2-12.3c0-6.8,5.6-12.3,12.3-12.3c6.8,0.1,12.2,5.6,12.2,12.4C90.8,85.9,85.3,91.4,78.6,91.3z  M73.7,79c0,2.7,2.2,4.9,4.8,5c2.6,0,4.9-2.2,4.9-4.9c0-2.6-2.2-4.9-4.8-4.9C76,74.1,73.7,76.3,73.7,79z"></path>
                                                        <path d="M34.2,91.3C27.4,91.3,22,85.8,22,79c0-6.8,5.5-12.3,12.2-12.3c6.7,0,12.3,5.6,12.2,12.3C46.4,85.9,40.9,91.4,34.2,91.3 L34.2,91.3z M39.1,79c0-2.7-2.2-4.9-4.9-4.9c-2.6,0-4.9,2.3-4.9,4.9c0,2.7,2.3,4.9,4.9,4.9C36.9,83.9,39.1,81.7,39.1,79z"></path>
                                                      </svg>
                                                    </i>
                                                  </span>
                                                  <span className="wdt-shop-menu-cart-number">
                                                    {cartList?.length}
                                                  </span>
                                                </span>
                                                <span className="wdt-shop-menu-cart-totals"></span>
                                              </span>
                                            </Link>
                                          )}
                                        </div>
                                      </div>
                                      <div className="wdt-wishlist-count">
                                        {token ? (
                                          <Link
                                            to="/wishlist"
                                            name=""
                                            aria-label=""
                                            className="wishlist_products_counter  top_wishlist- no-txt wishlist-counter-with-products"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              class="lucide lucide-heart"
                                            >
                                              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                            </svg>
                                            <span className="wishlist_products_counter_text"></span>
                                            <span className="wishlist_products_counter_number">
                                              {wishList?.length}
                                            </span>
                                          </Link>
                                        ) : (
                                          <Link
                                            onClick={() => {
                                              setLoginModal(true);
                                            }}
                                            name=""
                                            aria-label=""
                                            className="wishlist_products_counter  top_wishlist- no-txt wishlist-counter-with-products"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              class="lucide lucide-heart"
                                            >
                                              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                            </svg>
                                            <span className="wishlist_products_counter_text"></span>
                                            <span className="wishlist_products_counter_number">
                                              {wishList?.length}
                                            </span>
                                          </Link>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* Icon Section For Small Laptop End*/}

                              {/* Logo Section Start */}
                              <div
                                className="elementor-element elementor-element-0178a32 elementor-hidden-tablet_extra elementor-hidden-tablet elementor-widget elementor-widget-wdt-logo"
                                data-id="0178a32"
                                data-element_type="widget"
                                data-settings='{"wdt_animation_effect":"none"}'
                                data-widget_type="wdt-logo.default"
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    id="furniforma-0178a32"
                                    className="wdt-logo-container"
                                  >
                                    <Link to="/" rel="home">
                                      <img
                                        src={Logo}
                                        style={{ height: 100, width: 100 }}
                                        alt="FurniForma Site"
                                      />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              {/* Logo Section End */}
                            </div>
                          </div>

                          {/* Middle Section of Menu */}
                          <div
                            className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-d8619c3 elementor-hidden-mobile_extra elementor-hidden-mobile"
                            data-id="d8619c3"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-91daa8d elementor-align-center elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile elementor-widget elementor-widget-wdt-header-menu"
                                data-id="91daa8d"
                                data-element_type="widget"
                                data-settings='{"wdt_animation_effect":"none"}'
                                data-widget_type="wdt-header-menu.default"
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    className="wdt-header-menu"
                                    data-menu="4"
                                  >
                                    <div className="menu-container">
                                      <ul
                                        id="menu-main-menu-1"
                                        className="wdt-primary-nav"
                                        data-menu="4"
                                      >
                                        {headerData?.map((item, i) => {
                                          return (
                                            <li
                                              key={i}
                                              className={`menu-item menu-item-type-custom menu-item-object-custom ${
                                                item?.subMenu?.length > 0
                                                  ? "menu-item-has-children"
                                                  : ""
                                              } menu-item-315 menu-item-depth-0`}
                                            >
                                              {item?.subMenu?.length > 0 ? (
                                                <Link to="">
                                                  <span data-text="%1$s">
                                                    {item?.title}
                                                  </span>
                                                </Link>
                                              ) : (
                                                <Link to={item?.link}>
                                                  <span data-text="%1$s">
                                                    {item?.title}
                                                  </span>
                                                </Link>
                                              )}
                                              {item?.subMenu?.length > 0 && (
                                                <ul className="sub-menu is-hidden">
                                                  <li className="see-all"></li>
                                                  {item?.subMenu?.map(
                                                    (subItem, j) => {
                                                      return (
                                                        <li
                                                          key={j}
                                                          className="menu-item menu-item-type-post_type menu-item-object-page menu-item-839 menu-item-depth-1"
                                                        >
                                                          <Link
                                                            to={subItem?.link}
                                                          >
                                                            <span>
                                                              {subItem?.title}
                                                            </span>
                                                          </Link>
                                                        </li>
                                                      );
                                                    }
                                                  )}{" "}
                                                </ul>
                                              )}
                                            </li>
                                          );
                                        })}
                                      </ul>
                                      <div className="sub-menu-overlay"></div>
                                    </div>
                                    <div
                                      className="mobile-nav-container mobile-nav-offcanvas-right"
                                      data-menu="4"
                                      onClick={() => {
                                        setOpen(!open);
                                      }}
                                    >
                                      <Link
                                        to="/"
                                        className="menu-trigger menu-trigger-icon"
                                        data-menu="4"
                                      >
                                        <i></i>
                                        <span>Menu</span>
                                      </Link>
                                      <div
                                        className="mobile-menu"
                                        data-menu="4"
                                      ></div>
                                      <div className="overlay"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-bf61d4f elementor-tablet_extra-align-center elementor-hidden-desktop elementor-hidden-laptop elementor-hidden-mobile_extra elementor-hidden-mobile elementor-widget elementor-widget-wdt-logo"
                                data-id="bf61d4f"
                                data-element_type="widget"
                                data-settings='{"wdt_animation_effect":"none"}'
                                data-widget_type="wdt-logo.default"
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    id="furniforma-bf61d4f"
                                    className="wdt-logo-container"
                                  >
                                    <Link to={"/"} rel="home">
                                      <img
                                        src={Logo}
                                        style={{ height: 100, width: 100 }}
                                        alt="FurniForma Site"
                                      />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Last Icon Section  */}
                          <div
                            className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-6cc949e"
                            data-id="6cc949e"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-4c38bcc elementor-align-right elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile  elementor-widget elementor-widget-wdt-header-icons"
                                data-id="4c38bcc"
                                data-element_type="widget"
                                data-settings='{"_animation":"fadeIn","_animation_delay":300,"wdt_animation_effect":"none"}'
                                data-widget_type="wdt-header-icons.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="woocommerce">
                                    <div className="wdt-header-icons-list">
                                      <div className="wdt-header-icons-list-item cart-item">
                                        <div className="wdt-shop-menu-icon">
                                          {token ? (
                                            <Link to="/cart">
                                              <span className="wdt-shop-menu-icon-wrapper">
                                                <span className="wdt-shop-menu-cart-inner">
                                                  <span className="wdt-shop-menu-cart-icon">
                                                    <i>
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 100 92.3"
                                                      >
                                                        <path d="M1,3.7c0.9-2.2,2.5-2.9,4.8-2.8C9.2,1,12.6,1,16,1c2.7,0,3.9,0.9,4.5,3.6c1,4.3,2.1,8.7,3.1,13.1c0.4,0,0.9,0,1.3,0 c23.1,0,46.2,0,69.4,0c0.5,0,1,0,1.4,0.1c2.4,0.3,3.7,2.3,3.1,4.7c-2.7,10.9-5.3,21.8-8,32.7c-0.3,1.1-0.5,2.1-0.8,3.2 c-0.6,2.2-1.8,3.1-4.1,3.2c-7.5,0-15.1,0-22.6,0c-11.1,0-22.1,0-33.2,0c-2.9,0-4-0.9-4.7-3.7c-3.8-16.2-7.7-32.3-11.5-48.5 c-0.2-0.7-0.4-0.9-1.1-0.9c-2.4,0-4.7-0.1-7.1,0C3.6,8.5,2,7.8,1,5.6V3.7L1,3.7z M90.6,25.2H25.4c2.3,9.6,4.6,19.2,6.8,28.9h0.8 c16.5,0,33,0,49.6,0c0.6,0,0.9-0.2,1.1-0.8c1.4-5.9,2.9-11.8,4.4-17.7C88.9,32.1,89.8,28.6,90.6,25.2z"></path>
                                                        <path d="M78.6,91.3c-6.8,0-12.3-5.6-12.2-12.3c0-6.8,5.6-12.3,12.3-12.3c6.8,0.1,12.2,5.6,12.2,12.4C90.8,85.9,85.3,91.4,78.6,91.3z  M73.7,79c0,2.7,2.2,4.9,4.8,5c2.6,0,4.9-2.2,4.9-4.9c0-2.6-2.2-4.9-4.8-4.9C76,74.1,73.7,76.3,73.7,79z"></path>
                                                        <path d="M34.2,91.3C27.4,91.3,22,85.8,22,79c0-6.8,5.5-12.3,12.2-12.3c6.7,0,12.3,5.6,12.2,12.3C46.4,85.9,40.9,91.4,34.2,91.3 L34.2,91.3z M39.1,79c0-2.7-2.2-4.9-4.9-4.9c-2.6,0-4.9,2.3-4.9,4.9c0,2.7,2.3,4.9,4.9,4.9C36.9,83.9,39.1,81.7,39.1,79z"></path>
                                                      </svg>
                                                    </i>
                                                  </span>
                                                  <span className="wdt-shop-menu-cart-number">
                                                    {cartList?.length}
                                                  </span>
                                                </span>
                                                <span className="wdt-shop-menu-cart-totals"></span>
                                              </span>
                                            </Link>
                                          ) : (
                                            <Link
                                              onClick={() => {
                                                setLoginModal(true);
                                              }}
                                            >
                                              <span className="wdt-shop-menu-icon-wrapper">
                                                <span className="wdt-shop-menu-cart-inner">
                                                  <span className="wdt-shop-menu-cart-icon">
                                                    <i>
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 100 92.3"
                                                      >
                                                        <path d="M1,3.7c0.9-2.2,2.5-2.9,4.8-2.8C9.2,1,12.6,1,16,1c2.7,0,3.9,0.9,4.5,3.6c1,4.3,2.1,8.7,3.1,13.1c0.4,0,0.9,0,1.3,0 c23.1,0,46.2,0,69.4,0c0.5,0,1,0,1.4,0.1c2.4,0.3,3.7,2.3,3.1,4.7c-2.7,10.9-5.3,21.8-8,32.7c-0.3,1.1-0.5,2.1-0.8,3.2 c-0.6,2.2-1.8,3.1-4.1,3.2c-7.5,0-15.1,0-22.6,0c-11.1,0-22.1,0-33.2,0c-2.9,0-4-0.9-4.7-3.7c-3.8-16.2-7.7-32.3-11.5-48.5 c-0.2-0.7-0.4-0.9-1.1-0.9c-2.4,0-4.7-0.1-7.1,0C3.6,8.5,2,7.8,1,5.6V3.7L1,3.7z M90.6,25.2H25.4c2.3,9.6,4.6,19.2,6.8,28.9h0.8 c16.5,0,33,0,49.6,0c0.6,0,0.9-0.2,1.1-0.8c1.4-5.9,2.9-11.8,4.4-17.7C88.9,32.1,89.8,28.6,90.6,25.2z"></path>
                                                        <path d="M78.6,91.3c-6.8,0-12.3-5.6-12.2-12.3c0-6.8,5.6-12.3,12.3-12.3c6.8,0.1,12.2,5.6,12.2,12.4C90.8,85.9,85.3,91.4,78.6,91.3z  M73.7,79c0,2.7,2.2,4.9,4.8,5c2.6,0,4.9-2.2,4.9-4.9c0-2.6-2.2-4.9-4.8-4.9C76,74.1,73.7,76.3,73.7,79z"></path>
                                                        <path d="M34.2,91.3C27.4,91.3,22,85.8,22,79c0-6.8,5.5-12.3,12.2-12.3c6.7,0,12.3,5.6,12.2,12.3C46.4,85.9,40.9,91.4,34.2,91.3 L34.2,91.3z M39.1,79c0-2.7-2.2-4.9-4.9-4.9c-2.6,0-4.9,2.3-4.9,4.9c0,2.7,2.3,4.9,4.9,4.9C36.9,83.9,39.1,81.7,39.1,79z"></path>
                                                      </svg>
                                                    </i>
                                                  </span>
                                                  <span className="wdt-shop-menu-cart-number">
                                                    {cartList?.length}
                                                  </span>
                                                </span>
                                                <span className="wdt-shop-menu-cart-totals"></span>
                                              </span>
                                            </Link>
                                          )}
                                        </div>
                                      </div>
                                      <div className="wdt-wishlist-count">
                                        {token ? (
                                          <Link
                                            to="/wishlist"
                                            name=""
                                            aria-label=""
                                            className="wishlist_products_counter  top_wishlist- no-txt wishlist-counter-with-products"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              class="lucide lucide-heart"
                                            >
                                              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                            </svg>
                                            <span className="wishlist_products_counter_text"></span>

                                            <span className="wishlist_products_counter_number">
                                              {wishList?.length}
                                            </span>
                                          </Link>
                                        ) : (
                                          <Link
                                            onClick={() => {
                                              setLoginModal(true);
                                            }}
                                            name=""
                                            aria-label=""
                                            className="wishlist_products_counter  top_wishlist- no-txt wishlist-counter-with-products"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              class="lucide lucide-heart"
                                            >
                                              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                            </svg>
                                            <span className="wishlist_products_counter_text"></span>

                                            <span className="wishlist_products_counter_number">
                                              {wishList?.length}
                                            </span>
                                          </Link>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-f4e4739 elementor-align-center elementor-tablet_extra-align-right elementor-widget-tablet_extra__width-auto elementor-hidden-desktop elementor-hidden-laptop elementor-widget elementor-widget-wdt-header-menu"
                                data-id="f4e4739"
                                data-element_type="widget"
                                data-settings='{"wdt_animation_effect":"none"}'
                                data-widget_type="wdt-header-menu.default"
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    className="wdt-header-menu"
                                    data-menu="4"
                                  >
                                    <div className="menu-container">
                                      <ul
                                        id="menu-main-menu-2"
                                        className="wdt-primary-nav"
                                        data-menu="4"
                                      >
                                        {headerData?.map((item, i) => (
                                          <li
                                            key={i}
                                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-317 menu-item-depth-0"
                                          >
                                            <Link to={item?.link}>
                                              <span data-text="%1$s">
                                                {item?.title}
                                              </span>
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                      <div className="sub-menu-overlay"></div>
                                    </div>
                                    <div
                                      className="mobile-nav-container mobile-nav-offcanvas-right"
                                      onClick={() => {
                                        setOpen(!open);
                                      }}
                                      data-menu="4"
                                    >
                                      <Link
                                        to="/"
                                        className="menu-trigger menu-trigger-icon"
                                        data-menu="4"
                                      >
                                        <i></i>
                                        <span>Menu</span>
                                      </Link>
                                      <div
                                        className="mobile-menu"
                                        data-menu="4"
                                      ></div>
                                      <div className="overlay"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </header>

      {open && (
        <div class="mobile-menu nav-is-visible">
          <ul id="menu-main-menu-2" class="wdt-primary-nav " data-menu="4">
            {" "}
            {headerData?.map((item, i) => (
              <li
                key={i}
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-317 menu-item-depth-0"
              >
                <Link
                  to={item?.link}
                  onClick={() => {
                    setOpen(!open);
                  }}
                >
                  <span data-text="%1$s">{item?.title}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

      {loginModal && <Login open={loginModal} setOpen={setLoginModal} />}
    </div>
  );
};

export default Header;
